import { jsonldTitle } from './JsonldStore';

export const updateJsonldTitle = (value) => jsonldTitle.update((oldValue) => value);

